import auth0 from 'auth0-js';
import history from '../../history';
import { AUTH_CONFIG } from './Auth.config';
import firebase from 'firebase';

export default class Auth {
    accessToken;
    idToken;
    expiresAt;
    userProfile;

    constructor() {
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuthentication = this.handleAuthentication.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.getAccessToken = this.getAccessToken.bind(this);
        this.getIdToken = this.getIdToken.bind(this);
        this.renewSession = this.renewSession.bind(this);
    }

    auth0 = new auth0.WebAuth({
        domain: AUTH_CONFIG.domain,
        clientID:  AUTH_CONFIG.clientId,
        redirectUri: AUTH_CONFIG.callbackUrl,
        responseType: 'token id_token',
        scope: 'openid'
    });

    login() {
        this.auth0.authorize();
    }

    signInFirebaseCustomToken = async () => {
        this.auth0.client.userInfo(this.accessToken, async (err, profile) => {
            if (profile) {
                let uid = profile.sub.includes("|") ? profile.sub.split('|')[1] : profile.sub;
                let customAuth = firebase.functions().httpsCallable('customAuth');
                try {
                    let mintedToken = await customAuth({msftUid: uid});
                    await firebase.auth().signInWithCustomToken(mintedToken.data.token).catch(function(error) {
                        console.log("Sign in custom token firebase error:", error);
                    });
                }
                catch(exc) {
                    console.log(exc);
                }
            } else {
                console.log("Error while accessing auth0 userInfo endpoint:", err);
            }
        });
    }

    handleAuthentication(props) {
        this.auth0.parseHash(async (err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
                await this.signInFirebaseCustomToken(authResult.idToken);
            } else if (err) {
                history.replace('/');
                console.log(err);
                // alert(`Error: ${err.error}.`);
            }
        });
    }
    
    getAccessToken() {
        return this.accessToken;
    }

    getIdToken() {
        return this.idToken;
    }
    
    setSession(authResult) {
        // Set isLoggedIn flag in localStorage
        localStorage.setItem('isLoggedIn', 'true');

        // Set the time that the access token will expire at
        let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();
        this.accessToken = authResult.accessToken;
        this.idToken = authResult.idToken;
        this.expiresAt = expiresAt;

        // navigate to the home route
        history.replace('/');
    }
    
      renewSession() {
        this.auth0.checkSession({}, async (err, authResult) => {
           if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
                await this.signInFirebaseCustomToken(authResult.idToken);
           } else if (err) {
             this.logout();
             console.log(err);
             alert(`Could not get a new token.`);
           }
        });
      }
    
      logout() {
        // Remove tokens and expiry time
        this.accessToken = null;
        this.idToken = null;
        this.expiresAt = 0;
        this.userProfile = null;
    
        // Remove isLoggedIn flag from localStorage
        localStorage.removeItem('isLoggedIn');

        firebase.auth().signOut().then(function() {
            // Sign-out successful.
          }).catch(function(error) {
            // An error happened.
          });
    
        // navigate to the home route
        history.replace('/');
      }
    
      isAuthenticated() {
        // Check whether the current time is past the
        // access token's expiry time
        let expiresAt = this.expiresAt;
        return new Date().getTime() < expiresAt;
      }
}